import { AxiosResponse } from 'axios'

import { _axios } from './axios'

const GET_SECURITY_INSIGHTS = '/security-insights'

export const securityInsightsApi = () => {
  const bulkCreate = async (params: {
    rows: {
      securityId: string
      targetURL: string
      title: string
    }[]
    type: number
  }): Promise<AxiosResponse<any>> => {
    return await _axios().post(GET_SECURITY_INSIGHTS, params)
  }

  return {
    bulkCreate,
  }
}
